/**
 * API Configuration
 * 
 * Handles API base URL configuration for different environments:
 * - Development: defaults to http://localhost:5000
 * - Production: uses same origin (empty string) as NGINX proxies both frontend and API
 * 
 * Set REACT_APP_API_BASE_URL environment variable to override the default.
 */

// Default to localhost:5000 for development
// In production, this should be empty string (same origin) or set via environment variable
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

/**
 * Constructs a full API URL from a path
 * @param {string} path - The API endpoint path (should start with /)
 * @returns {string} The full API URL
 */
export const getApiUrl = (path) => {
  return `${API_BASE_URL}${path}`;
};

export default API_BASE_URL;

